import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  message: {
    fontStyle: 'italic',
    marginTop: '1rem',
    whiteSpace: 'nowrap',
  },
}));

export default useStyles;
